export const MODULE_BASE = '/cartes-acces'

export const CARD_TYPE = {
  ACCES: 'carte_acces',
  BIEN_ETRE: 'bien_etre',
}

export const CARD_TYPE_LABELS = {
  [CARD_TYPE.ACCES]: "Carte d'accès",
  [CARD_TYPE.BIEN_ETRE]: 'Bien-être',
}

export const CARD_TYPE_OPTIONS = [
  { value: CARD_TYPE.ACCES, label: CARD_TYPE_LABELS[CARD_TYPE.ACCES] },
  { value: CARD_TYPE.BIEN_ETRE, label: CARD_TYPE_LABELS[CARD_TYPE.BIEN_ETRE] },
]

export const FACILITY_TYPE = {
  HOTEL: 'hotel',
  CENTRE: 'centre_bien_etre',
}

export const RESERVATION_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  USED: 'used',
}

export const RESERVATION_STATUS_LABELS = {
  [RESERVATION_STATUS.PENDING]: 'En attente',
  [RESERVATION_STATUS.CONFIRMED]: 'Confirmée',
  [RESERVATION_STATUS.CANCELLED]: 'Annulée',
  [RESERVATION_STATUS.USED]: 'Utilisée',
}

export const RESERVATION_STATUS_FLOW = [
  RESERVATION_STATUS.PENDING,
  RESERVATION_STATUS.CONFIRMED,
  RESERVATION_STATUS.USED,
]

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]
export const DEFAULT_PAGE_SIZE = 25

export const SORT_OPTIONS = [
  { value: 'relevance', label: 'Pertinence' },
  { value: 'price_asc', label: 'Prix croissant' },
  { value: 'price_desc', label: 'Prix décroissant' },
  { value: 'start_date', label: 'Date de début' },
]

export const COUNTRY_OPTIONS = [
  { value: 'TN', label: 'Tunisie' },
  { value: 'FR', label: 'France' },
  { value: 'MA', label: 'Maroc' },
  { value: 'DZ', label: 'Algérie' },
  { value: 'IT', label: 'Italie' },
  { value: 'ES', label: 'Espagne' },
]
